//useEffect = Método chamado ao carragar a página;
import React, { useContext, useEffect, useState} from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
//import { Link } from 'react-router-dom';
//import { GiBullseye } from "react-icons/gi";
import { FaUsers, FaUserFriends, FaBuilding, FaClipboardList, FaHome, FaSignOutAlt, FaRegPaperPlane, FaFileInvoiceDollar, FaSatelliteDish, FaCalendarDay, FaSignInAlt } from "react-icons/fa";
import Modal from 'react-modal';
import logo from '../../assets/logo-home.png';
import Api from '../../services/Api'
import DashboardHome from './DashboardHome';
import DashboardBusiness from './DashboardBusiness';
import DashboardCustomers from './DashboardCustomers';
import DashboardCalls from './DashboardCalls';
import DashboardFinances from './DashboardFinances';
import DashboardUsers from './DashboardUsers';
import Loading from '../../components/Loading';
import UserContext from '../../contexts/UserContext';
import Functions from '../../components/Functions';
import CountrySelector from '../../components/CountrySelector';
import '../../styles/CountrySelector.css';
import './styles.css';

Modal.setAppElement(document.getElementById('root'));

export default function Dashboard({ history }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [toggleMenu, setToggleMenu] = useState(false);
  const [listMenuActive, setListMenuActive] = useState(0);
  const [labelTitle, setLabelTitle] = useState("");
  const [modalPassword, setModalPassword] = useState(false);
  const [pass, setPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [newPassConfirm, setNewPassConfirm] = useState('');
  const [modalEmail, setModalEmail] = useState(false);
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [file, setFile] = useState([]);
  const {user, setUser} = useContext(UserContext);
  const location = useLocation();

  const customStylesModal = {
    overlay: {
      background: 'rgba(0,0,0,0.5)',
      zIndex: 999
    }, 
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '95%',
      maxWidth: '550px',
      border: 0,
      padding: '15px',
      borderRadius: '15px',
      boxShadow: '0px 0px 5px -2px #bbbbbb'
    }
  };

  useEffect(() => {
    console.log(user);
    const user_id = localStorage.getItem('user');
    if(user_id) {
      validateLogin(user_id);
    } else {
      history.push('/login');
    }
  }, []);

  useEffect(() => {
    //console.log('Change history...');
    if(history.location.pathname.indexOf('/customers') !== -1){
      optionMenu(2);
    } else if(history.location.pathname.indexOf('/calls') !== -1){
      optionMenu(3);
      if(history.location.pathname.indexOf('/calls/new') !== -1){
        setLabelTitle(t('dashboard.menu.appointment'));
      }
    } else if(history.location.pathname.indexOf('/business') !== -1){
      optionMenu(5);
    } else if(history.location.pathname.indexOf('/users') !== -1){
      optionMenu(6);
    } else if(history.location.pathname.indexOf('/financeiro') !== -1){
      //optionMenu(9);
    } else {
      optionMenu(0);
    }
  }, [location]);

  async function validateLogin(user_id) {
    if(user_id){
      const response = await Api.getUser(user_id);
      if(response && response.hasOwnProperty('_id')){
        console.log("Usuário logado!")
        console.log(response);
        setUser([response]);
        if(!response.business?.subscription || moment(response.business.subscription.expiration_date) < moment()){
          console.log("Plano expirado!");
          toast.error(t('dashboard.errors.planExpired'), {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          history.push('/dashboard/business?expiration_plan=true');
        }
        setLoading(false);
      } else {
        history.push('/login');
        setUser([]);
      }
    }
  }

  function onChangeFile(e){
    if(e.target.files[0]){
      let file_size = e.target.files[0].size;
      //let file_name = e.target.files[0].name;
      //let file_type = e.target.files[0].type;
      //console.log('executou o file change: ' +  file_size);
      //Se maior que um 1mb(1048576)
      if(parseInt(file_size) >= 1048000) {
        toast.error(t('dashboard.modals.sendEmail.error.fileSize'), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }else{
        setFile(e.target.files[0]);
      }
    }
  };

  async function sendEmail(e){
    e.preventDefault();
    if(email !== "" && Functions.validateEmail(email) && subject !== "" && body !== ""){
      const data = new FormData();
      data.append('to', email);
      data.append('subject', subject);
      data.append('mail', body);
      if(file && typeof file === "object")
        data.append('file', file);
      const response = await Api.sendEmail(data);
      console.log(response);
      if(response && response.status === 200){
        setModalEmail(false);
        toast.success(t('dashboard.modals.sendEmail.success'), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        setEmail('');
        setSubject('');
        setBody('');
        setFile([]);
      } else {
        toast.error(response.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } else {
      toast.error(t('dashboard.modals.sendEmail.error.fillFields'), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }

  async function changePass(e){
    e.preventDefault();
    if(pass && pass !== "" && newPass && newPass !== "" && newPassConfirm && newPassConfirm !== ""){
      if(newPass === newPassConfirm && newPass !== ""){
        if(newPass.length >= 6){
          const response = await Api.updatePass(user[0]._id, pass.trim(), newPass.trim());
          console.log(response);
          if(response?.nModified && response.nModified === 1){
            setModalPassword(false);
            toast.success(t('dashboard.modals.changePassword.success'), {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            setPass('');
            setNewPass('');
            setNewPassConfirm('');
          } else {
            toast.error(response.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          }
        } else {
          toast.error(t('dashboard.modals.changePassword.error.passwordLength'), {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        }
      } else {
        toast.error(t('dashboard.modals.changePassword.error.passwordMatch'), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } else {
      toast.error(t('dashboard.modals.changePassword.error.fillFields'), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }

  function logout(){
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUser([]);
    history.push('/');
  }

  function optionMenu(menu){
    if(menu === 1) {
      setListMenuActive(1);
      setLabelTitle("");
    } else if(menu === 2) {
      setListMenuActive(2);
      setLabelTitle(t('dashboard.menu.patients'));
    } else if(menu === 3) {
      setListMenuActive(3);
      setLabelTitle(t('dashboard.menu.appointments'));
      if(history.location.pathname.indexOf('/calls/new') !== -1){
        setLabelTitle(t('dashboard.menu.appointments'));
      }
    } else if(menu === 5) {
      setListMenuActive(5);
      setLabelTitle(t('dashboard.menu.clinic'));
    } else if(menu === 6) {
      setListMenuActive(6);
      setLabelTitle(t('dashboard.menu.users'));
    } else if(menu === 4) {
      logout();
    } else {
      setListMenuActive(0);
      setLabelTitle("");
    }
    setToggleMenu(false);
  }
  
  if(user.length > 0){
    return (
    <>
      <div className="barraSuperior">
        <div className="row v-center">
          <div className="col-4 text-left logo">
            {/*<img id="logo-barra" src={logo} width="100%" onClick={() => {history.push('/dashboard'); optionMenu(0)}} style={{cursor: "pointer"}}/>*/}
            <h1 onClick={() => {history.push('/dashboard'); optionMenu(0);}} style={{cursor: "pointer"}}>e-iris.</h1>  
          </div>
          <div className="col-4 text-center">
            <span id="titleMenu">{labelTitle}</span>
          </div>
          <div className="col-4 imgMenu">
            <div className="row text-right">
              <CountrySelector />
              <span id="btnMenu" className={toggleMenu ? "fa fa-times fa-2x" : "fa fa-bars fa-2x"} style={{fontSize: '2.2em'}} onClick={() => toggleMenu ? setToggleMenu(false) : setToggleMenu(true)} alt="Menu" ></span>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <Loading visible={loading}/>
      </div>
      <div className="container">
        <ul id="menuUser" className={`${toggleMenu ? 'active' : ''}`}>
          <li onClick={() => {history.push('/dashboard'); optionMenu(0);}} className={`${listMenuActive === 0 ? 'active' : ''}`}><FaHome size="2em" className="itemHomeIcon"/> {t('dashboard.menu.home')} </li>
          <li onClick={() => history.push('/dashboard/calls')} className={`${listMenuActive === 3 ? 'active' : ''}`}><FaClipboardList size="2em" className="itemHomeIcon"/> {t('dashboard.menu.appointments')} </li>
          <li onClick={() => history.push('/dashboard/customers')} className={`${listMenuActive === 2 ? 'active' : ''}`}><FaUsers size="2em" className="itemHomeIcon"/> {t('dashboard.menu.patients')} </li>
          {user[0]?.adminBusiness && user[0].adminBusiness ? 
          <>
            {/*<li onClick={() => history.push('/dashboard/financeiro')} className={`${listMenuActive ===  9 ? 'active' : ''}`}><FaFileInvoiceDollar size="2em" className="itemHomeIcon"/> Financeiro </li> */}
            <li onClick={() => history.push('/dashboard/business')} className={`${listMenuActive === 5 ? 'active' : ''}`}><FaBuilding size="2em" className="itemHomeIcon"/> {t('dashboard.menu.clinic')} </li>
            <li onClick={() => history.push('/dashboard/users')} className={`${listMenuActive === 6 ? 'active' : ''}`}><FaUserFriends size="2em" className="itemHomeIcon"/> {t('dashboard.menu.users')} </li>
          </>
          : <></> }
          <li onClick={() => optionMenu(4)} className={`${listMenuActive === 4 ? 'active' : ''}`}><FaSignOutAlt size="2em" className="itemHomeIcon"/> {t('dashboard.menu.logout')}</li>
        </ul>
        <br /><br />
        <div className="row v-center">
          {listMenuActive === 0 ? <DashboardHome history={history} callbackParent={(menu) => optionMenu(menu)} loading={loading} setLoading={(value) => setLoading(value)} modalPassword={modalPassword} setModalPassword={(value) => setModalPassword(value)} reloadUser={() => validateLogin(user[0]._id)}/> : ''}
          {listMenuActive === 2 ? <DashboardCustomers history={history} loading={loading} setLoading={(value) => setLoading(value)} sendEmail={(value) => {setEmail(value); setModalEmail(!modalEmail)}}/> : ''}
          {listMenuActive === 3 ? <DashboardCalls history={history} loading={loading} setLoading={(value) => setLoading(value)} /> : ''}
          {listMenuActive === 5 ? <DashboardBusiness history={history} loading={loading} setLoading={(value) => setLoading(value)} modalPassword={modalPassword} setModalPassword={(value) => setModalPassword(value)} reloadUser={() => validateLogin(user[0]._id)} /> : ''}
          {listMenuActive === 6 ? <DashboardUsers history={history} loading={loading} setLoading={(value) => setLoading(value)} sendEmail={(value) => {setEmail(value);}} reloadUser={() => validateLogin(user[0]._id)} /> : ''}
          {listMenuActive === 9 ? <DashboardFinances history={history} loading={loading} setLoading={(value) => setLoading(value)} /> : ''}
        </div>
        <Modal
          isOpen={modalPassword}
          //onAfterOpen={afterOpenModal}
          onRequestClose={() => {setModalPassword(!modalPassword)}}
          style={customStylesModal}
          contentLabel={t('dashboard.modals.changePassword.title')}
        >
          <button className="btnCloseModal" onClick={() => {setModalPassword(!modalPassword)}}>✘</button>
          <div className="form-group col-12 text-center">
            <br />
            <h4 style={{marginBottom: '1.5rem'}}><b>{t('dashboard.modals.changePassword.title')}</b></h4>
          </div>
          <form onSubmit={changePass}>
            <div className="form-group col-12">
              <label className="labelInput">{t('dashboard.modals.changePassword.currentPassword')}</label>
              <input 
                type="password"
                className="form-control" 
                placeholder={t('dashboard.modals.changePassword.currentPasswordPlaceholder')}
                value={pass}
                onChange={event => setPass(event.target.value)}
              />
            </div>
            <div className="form-group col-12">
              <label className="labelInput">{t('dashboard.modals.changePassword.newPassword')}</label>
              <input 
                type="password"
                className="form-control" 
                placeholder={t('dashboard.modals.changePassword.newPasswordPlaceholder')}
                value={newPass}
                onChange={event => setNewPass(event.target.value)}
              />
            </div>
            <div className="form-group col-12">
              <label className="labelInput">{t('dashboard.modals.changePassword.confirmPassword')}</label>
              <input 
                type="password" 
                className="form-control" 
                placeholder={t('dashboard.modals.changePassword.confirmPasswordPlaceholder')}
                value={newPassConfirm}
                onChange={event => setNewPassConfirm(event.target.value)}
              />
            </div>
            <br />
            <div className="form-group col-12 text-center">
              <button type="submit" className="btn btn-default"> {t('dashboard.modals.changePassword.submitButton')} </button>
            </div>
          </form>
        </Modal>
        <Modal
          isOpen={modalEmail}
          //onAfterOpen={afterOpenModal}
          onRequestClose={() => {setModalEmail(!modalEmail)}}
          style={customStylesModal}
          contentLabel={t('dashboard.modals.sendEmail.title')}
        >
          <button className="btnCloseModal" onClick={() => {setModalEmail(!modalEmail)}}>✘</button>
          <div className="form-group col-12 text-center">
            <br />
            <h4 style={{marginBottom: '1.5rem'}}><b>{t('dashboard.modals.sendEmail.title')}</b></h4>
          </div>
          <form onSubmit={sendEmail}>
            <div className="form-group col-12">
              <label className="labelInput">{t('dashboard.modals.sendEmail.email')}</label>
              <input 
                required
                type="text"
                className="form-control" 
                placeholder={t('dashboard.modals.sendEmail.emailPlaceholder')}
                value={email}
                onChange={event => setEmail(event.target.value)}
              />
            </div>
            <div className="form-group col-12">
              <label className="labelInput">{t('dashboard.modals.sendEmail.subject')}</label>
              <input 
                required
                type="text"
                className="form-control" 
                placeholder={t('dashboard.modals.sendEmail.subjectPlaceholder')}
                value={subject}
                onChange={event => setSubject(event.target.value)}
              />
            </div>
            <div className="form-group col-12">
              <label className="labelInput">{t('dashboard.modals.sendEmail.message')}</label>
              <textarea
                required
                type="text"  
                className="form-control" 
                rows="3"
                placeholder={t('dashboard.modals.sendEmail.messagePlaceholder')}
                value={body}
                onChange={(event) => setBody(event.target.value)}
              />
            </div> 
            <div className="form-group col-12">
              <label className="labelInput">{t('dashboard.modals.sendEmail.attachment')}</label>
              <input type="file" className="form-control" onChange={onChangeFile} style={{fontSize: 14}}/>
            </div>
            <br />
            <div className="form-group col-12 text-center">
              <button type="submit" className="btn btn-default"> {t('dashboard.modals.sendEmail.submitButton')} </button>
            </div>
          </form>
        </Modal>
        <ToastContainer />
      </div>
    </>);
  } else {
    /*return (<div>Falha ao validar o usuário logado, você será redirecionado em...</div>)*/
    return (<div></div>)
  }
 
}